export const Settings = {
    widthOptions: {
        fit: '100px',
        full: null
    },
}